import type { SerializedMeterAddon } from '@enmon/commons/lib/tools';
import { Space, type TableColumnsType } from 'antd';
import { EmptyCell, Tag } from 'components';
import { Link } from 'react-router-dom';
import type { Key, SortOrder } from 'antd/lib/table/interface';
import { ActionButton } from '../../../../../components/button/Action';

export const getModulesColumnsConfig = ({
  loading,
  isMagicRole,
  onEdit,
  onDelete,
  sortState,
}: {
  loading: boolean;
  isMagicRole: boolean;
  onEdit: (addonId: SerializedMeterAddon['id']) => void;
  onDelete: (addonId: SerializedMeterAddon['id']) => void;
  sortState: { field: Key | null; order: SortOrder };
}): TableColumnsType<SerializedMeterAddon> => [
  {
    key: 'name',
    title: 'Name',
    sorter: true,
    sortOrder: sortState.field === 'name' ? sortState.order : null,
    width: 400,
    render: (_, record) => <Link to={{ pathname: `module/${record.id}` }}>{record.name}</Link>,
  },
  {
    key: 'technology',
    title: 'Technology',
    sorter: true,
    sortOrder: sortState.field === 'technology' ? sortState.order : null,
    width: 400,
    render: (_, record) =>
      record.technology ? (
        <Space wrap size={[0, 6]}>
          <Tag key={`${record.id}-${record.technology}`}>{record.technology}</Tag>
        </Space>
      ) : (
        <EmptyCell />
      ),
  },
  {
    key: 'modelsCount',
    title: 'Meter models count',
    sorter: true,
    sortOrder: sortState.field === 'modelsCount' ? sortState.order : null,
    width: 200,
    render: (_, record) => record.meter_models?.length ?? 0,
  },
  ...(isMagicRole
    ? ([
        {
          key: 'action',
          width: 150,
          title: 'Actions',
          fixed: 'right',
          render: (_, record) => (
            <ActionButton isLoading={loading} onClick={() => onEdit(record.id)} onDelete={() => onDelete(record.id)} />
          ),
        },
      ] satisfies TableColumnsType<SerializedMeterAddon>)
    : []),
];
